import { toLocalRecipientTime } from '../../../helpers/date';
import { Interval } from '../AppointmentCard.types';

export const prepareAppointmentTimeToCreateHomePickupCommand = ({
  appointmentTime,
}: {
  appointmentTime: Interval;
}) => {
  return {
    endTimeInLocalRecipientTimezone: toLocalRecipientTime(
      appointmentTime.endLocalTime,
    ),
    startTimeInLocalRecipientTimezone: toLocalRecipientTime(
      appointmentTime.startLocalTime,
    ),
  };
};
